/**
 * The server's error message from a failed response — sm4rt-api answers
 * `{error: "..."}` — or "{fallback}: {status} {statusText}" when the body is
 * not that shape. Shared by the newer service modules; older ones keep their
 * own copy (checkInApi.ts) until they are next touched.
 */
export async function readApiError(response: Response, fallback: string): Promise<string> {
  try {
    const body = await response.json();
    if (typeof body?.error === 'string') return body.error;
  } catch {
    /* not JSON */
  }
  return `${fallback}: ${response.status} ${response.statusText}`;
}
